module.exports = __webpack_public_path__ + "img/richText.e63ed7ed.svg";